import React, { Component } from "react";
import Chat from "./ChatHook";
import $ from 'jquery';

class ChatContainer extends Component {
  
  constructor(props) {
		super(props);
		this.state={
			chatCount: 0
		}
	}
 
	componentDidMount(){
		this.showChat();
	}
	
	componentDidUnMount(){
		window.chatWindow(null, false);
	}
	
	onChatCountUpdated = (count)=>{
	  this.setState({chatCount: count});
	}
	
	showChat = () => {
		window.chatWindow(true);
	}
	
	
	render() {
		return (
			<div className="right_menu_streaming chat_streaming">
				<div className="right_menu_title header_chat">Chat
					<div className="right_close close_chat" onClick={() => this.props.updateStateFromChild({rightMenuOpen: false, chatOpen: false})}></div>
				</div>
				<Chat onChatCountUpdated={this.onChatCountUpdated} />
			</div>		
	)}
}
export default ChatContainer;
